import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class ProformaService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('proformas/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('proformas/list', val_params);
  }

  previewDataForm(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('proformas/form/preview', val_params);
  }

  get(val_id: number) {
    return this.restService.get('proformas/edit', val_id);
  }

  detail(val_id: number) {
    return this.restService.get('proformas/detail', val_id);
  }

  save(data: any) {
    return this.restService.save('proformas/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('proformas/update', val_id, data);
  }

  delete(val_id: number) {
    return this.restService.delete('proformas/delete', val_id);
  }
  
}
